import React from "react";
import SvgIcon from "e100-react-components/lib/components/SvgIcon";
import { IProps } from "e100-react-components/lib/components/SvgIcon/index";

export const Battery0Bar = (props: IProps) => (
  <SvgIcon {...props}>
    <path d="M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1m-2 1H9v14h6z"></path>
  </SvgIcon>
);

export const Battery1Bar = (props: IProps) => (
  <SvgIcon {...props}>
    <path d="M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1m-2 1H9v12h6z"></path>
  </SvgIcon>
);

export const Battery2Bar = (props: IProps) => (
  <SvgIcon {...props}>
    <path d="M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1m-2 1H9v10h6z"></path>
  </SvgIcon>
);

export const Battery3Bar = (props: IProps) => (
  <SvgIcon {...props}>
    <path d="M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1m-2 1H9v8h6z"></path>
  </SvgIcon>
);

export const Battery4Bar = (props: IProps) => (
  <SvgIcon {...props}>
    <path d="M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1m-2 1H9v6h6z"></path>
  </SvgIcon>
);

export const Battery5Bar = (props: IProps) => (
  <SvgIcon {...props}>
    <path d="M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1m-2 1H9v4h6z"></path>
  </SvgIcon>
);

export const Battery6Bar = (props: IProps) => (
  <SvgIcon {...props}>
    <path d="M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1m-2 1H9v2h6z"></path>
  </SvgIcon>
);

export const BatteryFull = (props: IProps) => (
  <SvgIcon {...props}>
    <path d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4"></path>
  </SvgIcon>
);
